import { toast } from "react-toastify";
import i18n from 'i18next'


export default function showToast(content, type) {

    toast(i18n.t(content), { type: type ? type : "info" });
}